<template>
  <div>
    <b-overlay v-model="loading">
      <b-card title="Detail Admin Log" class="mb-4">
        <b-row>
          <b-col cols="12" style="margin-bottom: 15px;">
            <b-button variant="primary" @click="goBack()">
              <feather-icon size="1x" icon="ArrowLeftIcon" />Kembali ke Log Admin
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="User">
              <b-form-input :value="logDetail.user" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="Time Execution">
              <b-form-input :value="logDetail.createdAt" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="Action">
              <b-form-input :value="logDetail.action" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group label="Item Type">
              <b-form-input :value="logDetail.itemType" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-card title="Before">
              <pre>{{ logDetail.before }}</pre>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card title="After">
              <pre>{{ logDetail.after }}</pre>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logDetail: {
        user: '',
        createdAt: '',
        action: '',
        itemType: '',
      },
      loading: false,
      error: null
    }
  },
  mounted() {
    this.fetchLogDetail()
  },
  methods: {
    goBack() {
      window.history.back()
    },
    fetchLogDetail() {
      this.loading = true
      this.error = null
      const id = this.$route.params.id
      this.$store.dispatch('admin/getAdminLogById', { id })
        .then(res => {
          this.logDetail = {
            ...res,
            createdAt: new Date(res.createdAt).toLocaleString()
          }

        })
        .catch(err => {
          this.$bvToast.toast('Failed Fetching Data Log', {
          title: "Failed",
          variant: "danger",
          solid: true,
          });
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>